<template>
  <PHelpModal :title="title" :intro="intro" :steps="pipelines"/>
</template>

<script>
import PHelpModal from "@/domain/core/components/PHelpModal.vue";

export default {
  name: "ProcessingPipelineHelp",
  components: {PHelpModal},
  computed: {
    title() {
      return this.$pgettext('processing_pipeline.help', 'How processing pipelines work')
    },
    intro() {
      return this.$pgettext('processing_pipeline.help',
          'The selected pipeline determines how photos and videos uploaded to this gallery are processed. ' +
          'Choose the pipeline that matches the event media and filename convention.')
    },
    pipelines() {
      return [
        {
          title: this.$pgettext('processing_pipeline.help', 'Automatic'),
          text: this.$pgettext('processing_pipeline.help',
              'When selected on a parent gallery, the system routes uploaded content to its configured sub-galleries based on each sub-gallery\'s pipeline. ' +
              'For example, with a Photo sub-gallery and a Stadium sub-gallery, photos uploaded to the parent are distributed automatically: ' +
              'photos whose detected faces are small on average compared with the image dimensions are routed to Stadium, while the others are routed to Photo.')
        },
        {
          title: this.$pgettext('processing_pipeline.help', 'Photo'),
          text: this.$pgettext('processing_pipeline.help',
              'The standard photo pipeline. It applies facial recognition and, for sporting events, marker recognition.')
        },
        {
          title: this.$pgettext('processing_pipeline.help', 'Stadium'),
          text: this.$pgettext('processing_pipeline.help',
              'Designed for fan experience events. For each event photo, the system creates a personalized thumbnail for every recognized person. ' +
              'The crop is vertical with a 3:4 aspect ratio, centered on the face and approximately seven times the height of the face, so it includes the upper body and nearby people. ' +
              'Only photos with at least four recognized faces are processed. If the subject is too close to the edge and would be cut off, the photo is discarded. ' +
              'Upload high-resolution group photos with multiple participants, as typically captured in a stadium.')
        },
        {
          title: this.$pgettext('processing_pipeline.help', 'Video with cover'),
          text: this.$pgettext('processing_pipeline.help',
              'Upload a video and a JPEG cover with the same filename, apart from the extension. The filename is used to associate the cover with the video.')
        },
        {
          title: this.$pgettext('processing_pipeline.help', 'Video'),
          text: this.$pgettext('processing_pipeline.help',
              'Processes videos only. Any uploaded JPEG cover is ignored.')
        },
        {
          title: this.$pgettext('processing_pipeline.help', 'Video using BIB filename'),
          text: this.$pgettext('processing_pipeline.help',
              'Processes videos only and interprets each filename as the participant\'s BIB number. Any uploaded JPEG cover is ignored.')
        },
        {
          title: this.$pgettext('processing_pipeline.help', 'Video with cover using BIB filename'),
          text: this.$pgettext('processing_pipeline.help',
              'Processes video and JPEG cover pairs with the same filename, apart from the extension, and interprets that filename as the participant\'s BIB number.')
        }
      ]
    }
  }
}
</script>
